import * as React from 'react'
import Heading from 'LuxKit/Typography/Heading'

type Props = React.ComponentProps<typeof Heading>

function LeLiveHeading({ style, ...rest }: Props) {
  return <Heading {...rest} style={{ ...style, fontWeight: 400 }} />
}

export default LeLiveHeading
